module.exports = __webpack_public_path__ + "media/customizations/nolina/logo-new-8202536ab0e86bca29832191ec0e2116.png";